<template>
    <div>
        <div style="display: flex;justify-content: space-between;">
            <div style="font-weight: bold;">岗位信息</div>
            <Button class='ivu-btn-circle' type="primary" v-if="userInfo.menuList.homePage.talentPool_savePosition" @click="addClick">添加</Button>
        </div>
        <div style="margin-top: 30px;">
            <Table size="small" :columns="columns" :data="positionInfos">
                <div slot="operation" slot-scope="{ row }">
                    <a href="#" v-if="userInfo.menuList.homePage.talentPool_savePosition" @click="editPosition" :data-id="row.id" style="padding-right: 10px;">查看</a>
                    <a href="#" v-if="userInfo.menuList.homePage.talentPool_removePosition" @click="remove" :data-id="row.id">删除</a>
                </div>
            </Table>
        </div>

        <!-- 添加岗位对话框 -->
        <Modal v-model="modal" title="添加岗位" @on-ok="savePosition" @on-cancel="cancel" width="660" ok-text="保存">
            <Form :model="addPositionInfo" :label-width="100">
                <FormItem label="岗位名称">
                    <Input v-model="addPositionInfo.name" placeholder="请输入岗位名称"></Input>
                </FormItem>
                <FormItem label="岗位描述">
                    <Input v-model="addPositionInfo.description" type="textarea" :rows="3"
                           placeholder="请输入岗位描述"></Input>
                </FormItem>
                <FormItem label="岗位职责">
                    <Input v-model="addPositionInfo.responsibility" type="textarea" :rows="3"
                           placeholder="请输入岗位职责"></Input>
                </FormItem>
                <FormItem label="任职条件">
                    <Input v-model="addPositionInfo.requirement" type="textarea" :rows="3"
                           placeholder="请输入任职条件"></Input>
                </FormItem>
                <FormItem label="福利待遇">
                    <Input v-model="addPositionInfo.benefits" type="textarea" :rows="3" placeholder="请输入福利待遇"></Input>
                </FormItem>
                <FormItem label="岗位投递方式">
                    <Input v-model="addPositionInfo.delivery" type="textarea" :rows="3" placeholder="请输入岗位投递方式"></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {
        savePositionInfo, getAllPositionInfo, getPositionInfoById, delPositionInfoById
    } from '@/api/talent.js';

    export default {
        name: "Post",
        computed: {
            ...mapGetters(['userInfo', 'token']),
        },
        data() {
            return {
                modal: false,
                positionInfos: [],
                positionFilter: [],
                addPositionInfo: {
                    name: '',
                    description: '',
                    responsibility: '',
                    requirement: '',
                    benefits: '',
                    delivery: ''
                },
                columns: [{
                    title: '岗位名称',
                    key: 'position_name'
                },
                    {
                        title: '岗位投递数',
                        key: 'deliverCount'
                    },
                    {
                        title: '通过数',
                        key: 'passCount'
                    },
                    {
                        title: '入职数',
                        key: 'entryCount'
                    },
                    {
                        title: '操作',
                        key: 'operation',
                        "slot": "operation",
                    }
                ]
            }
        },

        methods: {
            addClick() {
                this.modal = true

            },
            //保存岗位信息
            savePosition() {
                let that = this
                let data = {token: that.token, positionInfo: that.addPositionInfo}
                savePositionInfo(data).then(function (res) {
                    that.getAllPositionInfo();
                    //清除页面数据
                    that.addPositionInfo = {
                        id: '',
                        name: '',
                        description: '',
                        responsibility: '',
                        requirement: '',
                        benefits: '',
                        delivery: ''
                    }
                });
            },
            cancel() {

            },
            getAllPositionInfo() {
                let that = this
                let data = {token: that.token}
                getAllPositionInfo(data).then(function (res) {
                    that.positionInfos = res.data.data
                    that.positionInfos.forEach((item) => {
                        that.positionFilter.push({label: item.position_name, value: item.position_name})
                    });
                });
            },
            editPosition(e) {
                let that = this;
                let id = e.currentTarget.dataset.id;
                let data = {token: that.token, positionId: id}
                getPositionInfoById(data).then(function (res) {
                    that.addPositionInfo = res.data.data
                    that.modal = true
                });

            },
            remove(e) {
                let that = this;
                let id = e.currentTarget.dataset.id;
                let data = {token: that.token, positionId: id}
                delPositionInfoById(data).then(function (res) {
                    that.getAllPositionInfo();
                })

            }
        }
    }
</script>

<style scoped lang="less">
</style>
